<div class="h-full w-full flex flex-col justify-start items-center overflow-hidden space-y-2">
  @if (hasTtoResults()) {

  <!-- Tabs Header -->
  <div
    class="flex-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">
    <div class="text-primary"></div>

    <div class="flex-1 flex flex-row items-center justify-end gap-x-4">
      <div class="hidden sm:block">
        <nav aria-label="Tabs" class="flex space-x-1">
          <a (click)="selectedTab.set('overview')"
            class="rounded-md px-2 py-2 text-xs font-medium cursor-pointer flex flex-row items-center justify-center"
            [class]="getTabClass('overview')">
            Overview
          </a>
          <a (click)="selectedTab.set('videos')"
            class="rounded-md px-2 py-2 text-xs font-medium cursor-pointer flex flex-row items-center justify-center"
            [class]="getTabClass('videos')">
            Videos
          </a>
        </nav>
      </div>
    </div>
  </div>
  <!-- Tabs Header - END -->

  <!-- Main Content -->
  <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">
    @switch (selectedTab()) {
    @case ('overview') {
    <ttor-overview class="w-full h-full"
      [ttoEngagements]="ttoEngagements()!.engagements_data"
      [contentPerformance]="ttoEngagements()!.content_performance_data"
      [audienceData]="ttoEngagements()!.audience_data">
    </ttor-overview>
    }
    @case ('videos') {
    <ttor-videos [videos]="ttoVideos()"></ttor-videos>
    }
    }
  </div>
  <!-- Main Content - END -->


  } @else if (showTtoEmptyState()) {
  <div class="w-full h-full flex items-center justify-center p-8">
    <div class="max-w-2xl text-center">
      <div
        class="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 dark:bg-primary/20 mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="size-10 text-accent">
          <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
          <circle cx="18.5" cy="5.5" r=".5" fill="currentColor" />
          <circle cx="11.5" cy="11.5" r=".5" fill="currentColor" />
          <circle cx="7.5" cy="16.5" r=".5" fill="currentColor" />
          <circle cx="17.5" cy="14.5" r=".5" fill="currentColor" />
          <path d="M3 3v16a2 2 0 0 0 2 2h16" />
        </svg>
      </div>
      <h2 class="text-2xl font-semibold text-primary mb-4">Brief Reporting</h2>
      <p class="text-base text-secondary leading-relaxed mb-6">
        Once content has been posted on social media, we can review the results and provide a report on the
        brief.
      </p>
      <div class="mt-8 space-y-3 text-left max-w-md mx-auto">
        <div class="flex items-start gap-3">
          <div class="shrink-0 mt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="text-accent">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          <p class="text-sm text-secondary">
            <span class="font-semibold text-primary">Comment Sentiment:</span> Understand what the audience thought of
            the content.
          </p>
        </div>
        <div class="flex items-start gap-3">
          <div class="shrink-0 mt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="text-accent">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          <p class="text-sm text-secondary">
            <span class="font-semibold text-primary">Brief Accuracy:</span> How accurately did the creators achieve the
            main brief points?
          </p>
        </div>
        <div class="flex items-start gap-3">
          <div class="shrink-0 mt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="text-accent">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          <p class="text-sm text-secondary">
            <span class="font-semibold text-primary">Content Performance:</span> Here you can see all social posts and
            their engagements
          </p>
        </div>
        <div class="flex items-start gap-3">
          <div class="shrink-0 mt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="text-accent">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          <p class="text-sm text-secondary">
            <span class="font-semibold text-primary">Top Performers:</span> Which posts got the most views, engagements
            and likes.
          </p>
        </div>
      </div>
    </div>
  </div>
  } @else {
  <atom-loading-inline title="Loading" message="Loading results..."></atom-loading-inline>
  }

</div>